import DeclineModal from '@containers/decline-modal';
import { ClientTrackingCategory } from '@models/client-tracking-category';
import Routes from '@models/routes';
import I9DocumentReviewPage from '@screens/review-section2/document-review/review-page';
import ReuploadDocumentsModal from '@screens/review-section2/reupload-documents-modal';
import {
    createDeclineModalStore,
    createDocumentReviewStore,
    createLoaderService,
    createReuploadDocumentsModalStore,
    createTranslationService
} from '@services/factories';
import { IDeclineModalStore } from '@stores/modal/decline-modal-store';
import { IDocumentReviewStore } from '@stores/onboarding-review/document-review-store';
import { IReuploadDocumentModalStore } from '@stores/modal/reupload-documents-modal-store';
import { cacheTranslations } from '@utils/cache-translations';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { observer } from 'mobx-react';

enum I9DocumentReviewTranslation {
    declineSection2Context = 'declineSection2Context'
}

@observer
class I9DocumentReview extends React.Component<RouteComponentProps> {
    // Probably good idea to dependency inject these later
    store: IDocumentReviewStore = createDocumentReviewStore();
    declineModalStore: IDeclineModalStore = createDeclineModalStore();
    reuploadDocumentsModalStore: IReuploadDocumentModalStore = createReuploadDocumentsModalStore();

    readonly translations = cacheTranslations(
        createTranslationService(),
        I9DocumentReviewTranslation
    );

    async componentDidMount() {
        // perhaps initialise the store here too?
        this.store.initialise();

        createLoaderService().showLoader();
        await this.store.loadDocuments();
        createLoaderService().hideLoader();
    }

    componentWillUnmount() {
        this.store.cleanupDocuments();
    }

    handleConfirmation = async () => {
        createLoaderService().showLoader();
        await this.store.submitConfirmationAsync();
        createLoaderService().hideLoader();

        if (this.store.confirmationRequestStatus !== 'success') {
            return;
        }

        this.props.history.push(Routes.Section2EmployeeInformation);
    };

    handleDeclineSuccess = () => this.props.history.push(Routes.Section2ThankYou);

    handleResubmitSuccess = () => {
        if (this.store.enabledUploadDocuments) {
            this.props.history.push(Routes.Section2UploadDocuments);
            return;
        }
        this.props.history.push(Routes.Section2ThankYou);
    }

    showDeclineModal = () => this.declineModalStore.openModal();

    showResubmitModal = () => this.reuploadDocumentsModalStore.openModal();

    render() {
        return (
            <React.Fragment>
                <I9DocumentReviewPage store={this.store}
                                      onConfirm={this.handleConfirmation}
                                      onDecline={this.showDeclineModal}
                                      onResubmit={this.showResubmitModal} />
                <DeclineModal store={this.declineModalStore}
                              declineQuestionContext={this.translations.declineSection2Context}
                              onDeclineSuccess={this.handleDeclineSuccess}
                              trackingCategory={ClientTrackingCategory.Section2Decline} />
                <ReuploadDocumentsModal store={this.reuploadDocumentsModalStore}
                                        onReuploadSuccess={this.handleResubmitSuccess}
                                        trackingCategory={ClientTrackingCategory.Section2ReuploadDocuments} />
            </React.Fragment>
        );
    }
}

export default I9DocumentReview;



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-review/index.tsx